import { BE_ADMIN_BASE } from "./environment";
import { apiPost } from "./apiClient";

export const getSearchAnalyticsAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/search-analytics`, payload, opts);

export const getSearchAnalyticsBreakdownAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/search-analytics/source-breakdown`, payload, opts);
